// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__Hv0CL","file":"styles_file__8Q_dV"};